import { EnvironmentProviders, Provider, importProvidersFrom } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { ROUTE_PROCESSOR } from '@frontend/vanilla/core';

import { extModules } from '../../environments/environment';
import { SportsWebLazyBootstrapService } from './bootstrap/sports-web-lazy-bootstrap.service';
import { SportsRouteProductProcessor } from './routing/sports-route-product-processor';

/**
 * Provides services needed for integrating Sports-Web into Host-App.
 * These services are not needed for starting Sports-Web as a standalone app.
 * They must be provided on route level for sports-web routes.
 * @returns Providers needed for Sports-Web integration.
 */
export function provideSportsWebHostApp(): (Provider | EnvironmentProviders)[] {
    return [
        // Host-App specific
        SportsWebLazyBootstrapService,
        {
            provide: ROUTE_PROCESSOR,
            useClass: SportsRouteProductProcessor,
            multi: true,
        },

        // External providers
        importProvidersFrom(extModules),
        importProvidersFrom(MatDialogModule),
    ];
}
